import { computed, ref, inject, getCurrentInstance } from 'vue';
import useEventBus from '@/plugins/eventBus'
import { isUrls } from '@/router/index.js';
import { getStore } from '@/store';
import useLng from '@/hooks/useLng';


const isHouseDetail = computed(() => {
    return isUrls({ names: ['listing-detail', 'sold-detail'], url: window.location.pathname });
})

const mapLayer = {
    google: {
        setMapLayer({ useHybrid, map, maps  }) {
            let layerType = useHybrid ? maps.MapTypeId.ROADMAP : maps.MapTypeId.HYBRID 
            map.setMapTypeId(layerType);
        }
    },
    here: {
        setMapLayer({ useHybrid, map, siteMap }) {
            let layer = useHybrid ? siteMap.baseLayer : siteMap.satelliteLayer
            //  set up zoom Maximum and minimum
            layer.setMin(siteMap.config.minZoom);
            layer.setMax(siteMap.config.maxZoom);
            map.setBaseLayer(layer);
        }
    }
}

const STATUS_MAP = {
    hybrid: 'hybrid', 
    roadmap: 'roadmap'
}

export function useMapType() {
    const eventBus = useEventBus()
    const status = ref(STATUS_MAP.hybrid)
    const applyMap = inject('applyMap', () => {})
    const $t = useLng('map')
    const { proxy } = getCurrentInstance()

    const mapType = getStore('page').page?.map?.type || 'here'
    const isHybrid = computed(() => status.value === STATUS_MAP.hybrid)
    const text = computed(() => isHybrid.value ? $t('satellite') : $t('map'))
    const iconImg = computed(() => { 
        return isHybrid.value
            ? 'https://cdn.chime.me/image/fs02/sitebuild/20181009/23/h120_original_1986408872806524.jpeg'
            : 'https://cdn.chime.me/image/fs02/sitebuild/20181009/23/h120_original_1986495654205811.png';
    })
    const isMobileSize = computed(() => proxy.platform.isMobile)
    const mobileIcon = computed(() => {
        return isHybrid.value ? 'icon-satellite' : 'icon-hybrid';
    })

    const handleMapType = async(event) => {
        let [map, maps, siteMap] = await applyMap()
        status.value = isHybrid.value ? STATUS_MAP.roadmap : STATUS_MAP.hybrid;
        mapLayer[mapType].setMapLayer({ useHybrid: isHybrid.value, map, maps, siteMap });
		
        if (isHouseDetail.value && !isHybrid.value) {
            map.setZoom(19);
            map.setCenter(siteMap.config.center);
        }
      
        eventBus.$emit('siteTrack', {
            action: 'map-type',
            label: isHybrid.value ? 'Map' : 'Satellite',
            trackType: 'map-event',
            ele: event.target
        });
    }

    return {
        $t,
        isMobileSize,
        mobileIcon,
        status,
        text,
        iconImg,
        handleMapType,
    }
} 